<template>
  <div class="animated fadeIn pt3 pb4 mb4">
    <div class="clearfix gibson px2 mb2">
      <div class="col-12 px2">
        <div v-if="showMobile">
          <div class="clearfix border muted-border p2 mb4 shadow">
            <div class="col-12 px2">
              <p class="h4 semi-bold darkblue gibson line-height-2 my3">Rediger kreditkort oplysninger</p>
              <b-alert variant="success" dismissible :show="showDismissibleAlert" @dismissed="showDismissibleAlert=false">
                <h5>Dine betalingskortoplysninger er nu registreret og gemt i vores system</h5>
              </b-alert>
              <b-alert variant="success" dismissible :show="showDismissibleAlertMobil" @dismissed="showDismissibleAlertMobil=false">
                <h5>Din Mobilepay er nu registreret og gemt i vores system</h5>
              </b-alert>
              <b-alert variant="danger" dismissible :show="showDismissibleAlertMobilf" @dismissed="showDismissibleAlertMobilf=false">
                <h5>Ikke gennemføres - kontakt venligst Håndværker.dk support på info@haandvaerker.dk</h5>
              </b-alert>
              <p class="h5 regular gibson darkblue line-height-golden mb2">
                Hvis du har brug for at ændre dine kreditkortoplysninger, eksempelvis for at skifte et kort ud med et andet, så har du mulighed for at gøre det her.
                <br>
                Vi gør hermed opmærksom på at det er reepay.dk (PBS) der varertager al sikkerhed omkring betalingskortoplysninger, læs mere her:
              </p>
              <div class="py1"></div>
              <div class="flex flex-column">
                <div class="">
                  <button type="button"  @click="showpopupreepay" id="kreditcard" class="not-rounded action-button gibson h5 regular no-hover flex justify-center items-center p2 line-height-1 mb0">
                    <span class="mr2"><i class="el-icon-bank-card white" style="font-size:30px"></i></span>
                    <span class="white h4 mb0">Tilmeld med kreditkort</span>
                  </button>
                </div>
                <!-- <div class="" v-else>
                  <a :href="`http://www.kundematch.dk/newpartner/kredit.php?id=${salesPerson}`" id="kreditcard" class="not-rounded action-button gibson h5 regular no-hover flex justify-center items-center p2 line-height-1 mb0">
                    <span class="mr2"><i class="el-icon-bank-card white" style="font-size:30px"></i></span>
                    <span class="white h4 mb0">Tilmeld med kreditkort</span>
                  </a>
                </div> -->
                <div class="py1"></div>
                <!-- <div>
                  <button class="border-none not-rounded white-background flex justify-center items-center" @click="showMobilePay = true" >
                    <img src="static/img/danish-outline-large3x_1.png" class="fit">
                  </button>
                  <br />
                  <b-link href="https://www.mobilepay.dk/hjaelp/mobilepay-til-private/brug/betalingsaftaler" target="_blank">MobilePay spørgsmål</b-link>
                </div> -->
              </div>
              <div class="py1"></div>
              <!-- <a :href="`http://www.kundematch.dk/newpartner/kredit.php?id=${salesPerson}`" class="not-rounded action-button gibson h5 regular col-12 flex justify-center items-center p2">
                <span>Rediger dine kreditkortoplysninger</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </a>
              <div class="py1"></div>
              <button :href="`http://www.kundematch.dk/newpartner/kredithaa.php?id=${salesPerson}`" class="standard-button p2 flex justify-start items-start gibson semi-bold not-rounded hide">
                <span class="mr1">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-credit-card-f"><path d='M20 4H0V2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2zm0 3v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h20zM4 9a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2H4zm5 0a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2H9z' /></svg>
                </span>
                <span class="h6 block line-height-2 left-align">Rediger dine håndværker kreditkortoplysninger</span>
              </button>
              <button class="border-none not-rounded">
                <img src="static/svg/mobilepay.svg">
              </button> -->
              <p class="h5 regular darkblue line-height-golden mt2 mb3">
                Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på <a href="tel:+4570228014" class="semi-bold">70 22 80 14</a> eller skriv til <a href="mailto:info@haandvaerker.dk" class="semi-bold">info@haandvaerker.dk</a>.
                <br>Vi gemmer via Nets dine kreditkortoplysninger til betaling af fremtidige betalinger. Vi gemmer oplysningerne indtil kortet skiftes. Ønsker du i fremtiden at benytte en anden form for betaling, så kontakt os venligst på <a href="tel:+4570228014" class="semi-bold">70 22 80 14</a>.
              </p>

            </div>
          </div>
          <div class="clearfix border muted-border p2 mb4 shadow">
            <div class="col-12 px2 pb2">
              <p class="h4 semi-bold darkblue my3">Send dine fakturaer til en email</p>
              <div class="mb3"></div>
              <p class="h5 regular gibson darkblue line-height-golden mb3">Indtast den eller de emailadresser du ønsker der automatisk skal modtage fakturaen, fx. en bogholder eller direkte til et regnskabsprogram.</p>
              <b-form class="flex col-12 border lightgrey-border p1 items-center mb2" @submit="addEmail()">
                <div class="col-9 p0">
                  <b-form-input type="email" v-model="email" placeholder="Skriv e-mail her..." class="border-none p1" autocomplete="off"></b-form-input>
                </div>
                <div class="col-3 p0">
                  <b-button type="submit" class="col-12 action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular"><span class="h5">Gem</span>
                  </b-button>
                </div>
              </b-form>
              <span class="h5 regular gibson darkblue line-height-golden mb3">Dine mailadresser:</span>
              <div class="mb2"></div>
              <div>
                <el-tag class="h6 regular darkblue block border-none transparent" v-for="(email,index) in invoiceEmailData.emailData" :key="index" :disable-transitions="true" closable v-confirm="{ok: confirmRemoveInvoiceEmail(invoiceEmailData.idData[index])}" style="width: max-content;">
                  {{email}}
                </el-tag>
              </div>
              <div>
                <span class="mediumgrey-text">{{invoiceEmailMessage}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix p2 ml4 mb4" v-if="!showMobile">
          <div class="lg-col-6 col-12 px2">
            <p class="h4 semi-bold darkblue gibson line-height-2 my3">Rediger kreditkort oplysninger</p>
            <b-alert variant="success" dismissible :show="showDismissibleAlert" @dismissed="showDismissibleAlert=false">
              <h5>Dine betalingskortoplysninger er nu registreret og gemt i vores system</h5>
            </b-alert>
            <b-alert variant="success" dismissible :show="showDismissibleAlertMobil" @dismissed="showDismissibleAlertMobil=false">
              <h5>Din Mobilepay er nu registreret og gemt i vores system</h5>
            </b-alert>
            <b-alert variant="danger" dismissible :show="showDismissibleAlertMobilf" @dismissed="showDismissibleAlertMobilf=false">
              <h5>Ikke gennemføres - kontakt venligst Håndværker.dk support på info@haandvaerker.dk</h5>
            </b-alert>
            <p class="h5 regular gibson darkblue line-height-golden mb2">
              Hvis du har brug for at ændre dine kreditkortoplysninger, eksempelvis for at skifte et kort ud med et andet, så har du mulighed for at gøre det her.
              <br>
              Vi gør hermed opmærksom på at det er reepay.dk (PBS) der varertager al sikkerhed omkring betalingskortoplysninger, læs mere her:
            </p>
            <div class="py1"></div>
            <div class="flex justify-between items-center">
              <div class="">
                <a type="button"  @click="showpopupreepay" class="not-rounded action-button gibson h5 regular no-hover flex justify-start items-center p2 line-height-1 mb0">
                  <span class="mr2"><i class="el-icon-bank-card white" style="font-size:30px"></i></span>
                  <span class="white h5 mb0 pr2">Tilmeld med kreditkort</span>
                </a>
                <br />
                <b-link href="https://www.epay.dk/sikkerhed/pci-certificeret-betalingssystem.asp"><br /></b-link>
              </div>
              <!-- <div class="" v-else >
                <a :href="`http://www.kundematch.dk/newpartner/kredit.php?id=${salesPerson}`" id="kreditcard" class="not-rounded action-button gibson h5 regular no-hover flex justify-start items-center p2 line-height-1 mb0">
                  <span class="mr2"><i class="el-icon-bank-card white" style="font-size:30px"></i></span>
                  <span class="white h5 mb0 pr2">Tilmeld med kreditkort</span>
                </a>
                <br />
                <b-link href="https://www.epay.dk/sikkerhed/pci-certificeret-betalingssystem.asp"><br /></b-link>
              </div> -->
              
              <!-- <div class="flex-auto ml2">
                <button class="border-none not-rounded white-background flex justify-center items-center" @click="showMobilePay = true" >
                  <img src="static/img/danish-outline-large3x_1.png" width="260">
                </button>
                <br />
                <b-link href="https://www.mobilepay.dk/hjaelp/mobilepay-til-private/brug/betalingsaftaler" target="_blank">MobilePay spørgsmål</b-link>
              </div> -->
            </div>
            <!-- <a :href="`http://www.kundematch.dk/newpartner/kredit.php?id=${salesPerson}`" class="not-rounded action-button gibson h5 regular no-hover col-7 flex justify-center items-center p2">
              <span class="white">Rediger dine kreditkortoplysninger</span>
              <span class="mx2"><i class="el-icon-right white"></i></span>
            </a> -->
            <!-- <div class="py1"></div> -->
            <!-- <button :href="`http://www.kundematch.dk/newpartner/kredithaa.php?id=${salesPerson}`" class="standard-button p2 flex justify-start items-start gibson semi-bold not-rounded hide">
              <span class="mr1">
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-credit-card-f"><path d='M20 4H0V2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2zm0 3v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h20zM4 9a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2H4zm5 0a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2H9z' /></svg>
              </span>
              <span class="h6 block line-height-2 left-align">Rediger dine håndværker kreditkortoplysninger</span>
            </button>
            <p class="h5 regular darkblue line-height-golden mt1">
              ------------------------------------------------------------------------------
            </p> -->
            <!-- <button class="border-none not-rounded" @click="showMobilePay = true" v-if="mobile === '25211200'">
              <img src="static/img/mobilepay.png" width="300">
            </button> -->
            <p class="h5 regular darkblue line-height-golden py2 mt2 mb3">
              Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på <a href="tel:+4570228014" class="semi-bold primarycolor">70 22 80 14</a> eller skriv til <a href="mailto:info@haandvaerker.dk" class="semi-bold primarycolor">info@haandvaerker.dk</a>.
              <br>Vi gemmer via Nets dine kreditkortoplysninger til betaling af fremtidige betalinger. Vi gemmer oplysningerne indtil kortet skiftes. Ønsker du i fremtiden at benytte en anden form for betaling, så kontakt os venligst på <a href="tel:+4570228014" class="semi-bold primarycolor">70 22 80 14</a>.
            </p>
            <span class="h4 semi-bold darkblue">Send dine fakturaer til en email</span>
            <div class="mb3"></div>
            <p class="h5 regular gibson darkblue line-height-golden mb3">Indtast den eller de emailadresser du ønsker der automatisk skal modtage fakturaen, fx. en bogholder eller direkte til et regnskabsprogram.</p>
            <b-form class="flex col-8 border lightgrey-border p1 items-center mb2" @submit="addEmail()">
              <div class="col-9 p0">
                <b-form-input type="email" v-model="email" placeholder="Skriv e-mail her..." class="border-none p1" autocomplete="off"></b-form-input>
              </div>
              <div class="col-3 p0">
                <b-button type="submit" class="col-12 action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular"><span class="h5">Gem</span>
                </b-button>
              </div>
            </b-form>
            <span class="h5 regular gibson darkblue line-height-golden mb3">Dine mailadresser:</span>
            <div class="mb2"></div>
            <div>
              <el-tag class="h6 regular darkblue block border-none transparent" v-for="(email,index) in invoiceEmailData.emailData" :key="index" :disable-transitions="true" closable v-confirm="{ok: confirmRemoveInvoiceEmail(invoiceEmailData.idData[index])}" style="width: max-content;">
                {{email}}
              </el-tag>
            </div>
            <div>
              <span class="mediumgrey-text">{{invoiceEmailMessage}}</span>
            </div>
          </div>
        </div>
        <b-modal lazy centered no-close-on-backdrop hide-footer v-model="showMobilePay"  title="Submit Your Name">
          <div class="clearfix p2">
            <b-button class="mt-3 right" variant="outline-primary"  @click="showMobilePay = false">X</b-button>
            <div class="flex flex-column col-12 justify-center items-center">
              <img src="static/svg/mobilepay.svg" alt="" class="mb2">
              <form action="" class="col-12">
                <div class="clearfix my3">
                  <p class="h6 gibson line-height-1 mb1">Mobilnr.</p>
                  <input type="tel" v-model="mobile" class="col-12 lightgrey-background p2 border-none not-rounded">
                </div>
              </form>
              <button @click="registerMobilepay()" :disabled="isLoadingReserve" class="col-6 p2 mx-auto not-rounded gibson line-height-1 h5 regular action-button">
                  <span>Tilmeld</span>
              </button>


            </div>

          </div>
        </b-modal>
        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
      </div>
      <b-modal id="dineNotater" v-model="demopopup" no-close-on-backdrop centered class="pt3 pr3 pb1 pl3">
        <div class="flex justify-end">
          <button type="reset" @click="closeDemoreserve" class="h4 bold p0 p2 border-none transparent">
            X
          </button>
        </div>
        <div class="p2">
          <p class="h5 darkblue center semi-bold line-height-1 mb3 gibson">
            <span class=" items-center">
               <img class="" width="60" src="static/img/thumbs-up-pngrepo-com.png">
            </span>
            <br /> <br />
            Sådan!
          </p>
          <p class="h5 darkblue semi-bold line-height-1 my3 gibson">
            Nu er dit abonnement opdateret og du kan fremadrettet reservere 2 opgaver af gangen.
            <br /><br />
            Ønsker du at reservere opgaven du kiggede på?

          <div class="center p2">
            <b-button type="button" @click="saveDemoreserve" class="col-6 action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular"><span class="h5">Ja tak <span class="el-icon-right mr-2"></span></span>
            </b-button>
          </div>
          </p>
        </div>
        <div slot="modal-footer" class="flex justify-start items-center col-12 px0">
        </div>

      </b-modal>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <updatebitrixpackagepermission   ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import updatebitrixpackagepermission from '../../components/updatebitrixpackagepermission'
import axios from 'axios'
export default {
  name: 'kreditkort',
  components: {
    loading,
    Simplert,
    axios,
    updatebitrixpackagepermission
  },
  data () {
    return {
      selected: '',
      salesPerson: '',
      show: false,
      shownewcreditpro: false,
      showsessionnewcreditpro: [],
      datamethod: '',
      rp: '',
      demopopup: false,
      mobile: '',
      label: 'Loading...',
      overlay: 1,
      basic: false,
      haaCredit: false,
      showimentor: true,
      showDismissibleAlertMobil: false,
      showDismissibleAlertMobilf: false,
      showDismissibleAlert: false,
      isLoadingReserve: false,
      showMobilePay: false,
      email: '',
      haaId: '',
      levid: '',
      invoiceEmailData: {
        emailData: [],
        idData: []
      },
      invoiceEmailMessage: ''
    }
  },
  watch: {
    'datamethod': function (newVal, oldVal) {
      this.givedatatoserver(newVal)
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.haaId = localStorage.getItem('haaid')
    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true
      if (localStorage.getItem('demoreserve')) {
        this.demopopup = true
      }
    }
    if (this.$route.query.credit === 'mobilepay') {
      this.showDismissibleAlertMobil = true
      if (localStorage.getItem('demoreserve')) {
        this.demopopup = true
      }
    }
    if (localStorage.getItem('imentor') === '0') {
      this.showimentor = false
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    console.log('initialval', this.datamethod)
    this.displayMobileAndEmail()
    this.shownewcredit()
    this.showsessionnewcredit()
    setTimeout(() => {
      if (document.querySelector('#dropMarkedsplads') !== null) {
        setTimeout(() => {
          var maketplace = document.querySelector('#dropMarkedsplads')
          maketplace.addEventListener('click', function () {
            window.location.replace('#/markedsplads')
          })
        }, 500)
      }
    }, 300)
  },
  methods: {
    shownewcredit () {
      var data = {
        operation: 'newcredit',
        salesPerson: this.salesPerson
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.shownewcreditpro = true
          }
        )
    },
    showsessionnewcredit () {
      var data = {
        operation: 'reepaysession',
        salesPerson: this.salesPerson,
        levid: this.haaId
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              var data = res.data
              this.showsessionnewcreditpro = data.id
            } else {
              console.log('Error in showing session')
            }
          }
        )
    },
    updateprofilepayment () {
      this.levid = this.haaId
      var data = {
        UF_CRM_COMPANY_PAYMENT_METHOD_UPDATED: 1
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplierCustomFields/' + this.levid, data, { emulateJSON: true }).then(
        (response) => {
          if (response.data.success) {
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    showpopupreepay () {
      var m = this
      this.rp = new window.Reepay.ModalCheckout(this.showsessionnewcreditpro)
      this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
        m.updateprofilepayment()
        m.datamethod = data.payment_method
      })
      // this.givedatatoserver(datamethod)
    },
    givedatatoserver (paymentmethod) {
      console.log('beforedata', paymentmethod)
      var data = {
        operation: 'savereepay',
        salesPerson: this.salesPerson,
        payment: paymentmethod,
        levid: this.haaId
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res) {
              // var data = res.data
              console.log('success add new credit card', res)
              // this.rp.destroy()
              // let obj = {
              //   title: 'Kreditkort opdateret!',
              //   message: '',
              //   type: 'success',
              //   customCloseBtnText: 'Luk'
              // }
              // this.$refs.simplert.openSimplert(obj)
              // this.email = ''
            } else {
              console.log('Error in showing epay')
            }
          }
        )
    },
    displayMobileAndEmail () {
      var data = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no'}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.mobile = res.mobile
            this.invoiceEmailData.emailData = []
            this.invoiceEmailData.idData = []
            if (!res.invoiceemail.length) {
              this.invoiceEmailMessage = 'Du har ikke en faktura-e-mail'
            } else {
              this.invoiceEmailMessage = ''
            }
            for (var i = 0; i < res.invoiceemail.length; i++) {
              this.invoiceEmailData.emailData.push(res.invoiceemail[i].email)
              this.invoiceEmailData.idData.push(res.invoiceemail[i].id)
            }
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.haaCredit = res.haacredit
            if (this.$route.query.credit === 'mobilepaycall') {
              this.registerMobilepay()
            }
            if (this.$route.query.credit === 'creditcall') {
              setTimeout(function () {
                var button = document.getElementById('kreditcard')
                button.click()
              }, 1000)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    registerMobilepay () {
      this.isLoadingReserve = true
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'registerMobilepay', salesPerson: this.salesPerson, mobile: this.mobile, mobilev: 0}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              window.location.href = res.url
            } else {
              this.isLoadingReserve = false
              this.show = false
              this.loading = false
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    // selectEmail (tag) {
    //   this.email = tag
    // },
    closeDemoreserve () {
      this.demopopup = false
      localStorage.removeItem('demoreserve')
    },
    saveDemoreserve () {
      var data = {
        operation: 'adddemoreserve',
        salesPerson: this.salesPerson,
        demoreserve: localStorage.getItem('demoreserve')
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.show = false
              let obj = {
                title: 'Reserveret!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.demopopup = false
              localStorage.removeItem('demoreserve')
            } else {
              alert('Ikke Gennemført')
              this.show = false
              console.log('Error in addEmail()')
            }
          },
          response => {
            console.log('Error in addEmail()')
          }
        )
    },
    addEmail () {
      event.preventDefault()
      if (this.email !== '') {
        this.show = true
        var data = {
          operation: 'addInvoiceEmail',
          salesPerson: this.salesPerson,
          email: this.email
        }
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              if (res.login === false) {
                this.$router.push('/login')
              }
              if (res.success) {
                this.displayMobileAndEmail()
                this.show = false
                let obj = {
                  title: 'E-mail tilføjet!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
                this.email = ''
              } else {
                this.show = false
                console.log('Error in addEmail()')
              }
            },
            response => {
              console.log('Error in addEmail()')
            }
          )
      } else {
        this.$toastr('error', 'Felt kræves')
      }
    },
    confirmRemoveInvoiceEmail (id) {
      return dialog => this.removeInvoiceEmail(id)
    },
    removeInvoiceEmail (id) {
      this.show = true
      var data = {
        operation: 'removeInvoiceEmail',
        salesPerson: this.salesPerson,
        emailid: id
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.displayMobileAndEmail()
              this.$toastr('success', 'Fjernet')
              this.show = false
            } else {
              this.show = false
              console.log('Error in removeInvoiceEmail()')
            }
          },
          response => {
            console.log('Error in removeInvoiceEmail()')
          }
        )
    }
  }
}
</script>
<style>
  i.el-tag__close.el-icon-close {
    border: 1px solid;
    color: #000;
  }
  i.el-tag__close.el-icon-close:hover {
    border: 1px solid;
    color: #000;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// EditCreditCard.vue?8e97845e